<template>
	<Sidebar v-model:visible="visible" :header="header" position="right" @hide="onHide">
		<div v-if="userRoleForm">
			<UserRolesForm :form="userRoleForm" @on-save="saveUserRole"/>
		</div>
	</Sidebar>
</template>

<script>
import { mapStores } from "pinia";
import UserRolesForm from "@/Forms/User/UserRolesForm.vue";
import { useUsersStore } from "@/stores/users.js";
import { useForm } from "laravel-precognition-vue";

export default {
	name: "AssignUserRoleSlideOver",
	components: {UserRolesForm},
	data() {
		return {
			visible: false,
			userRole: undefined,
			userRoleForm: undefined,
		}
	},
	computed: {
		...mapStores(useUsersStore),
		header() {
			return this.$t('slide_overs.assign_user_role_slide_over.manage_user_roles');
		},
	},
	methods: {
		async assignUserRole(user) {
			if (!user)
				return;

			this.user = user;
			this.userRoleForm = useForm('post', `/users/${ user.id }/roles`, {
				role_id: null,
				team_id: null,
			})

			this.visible = true;
		},
		async saveUserRole() {
			try {
				await this.userRoleForm.submit();
        this.$toast.add({
          severity: 'success',
          summary: this.$t('common.complete'),
          detail: this.$t('slide_overs.assign_user_role_slide_over.role_was_assigned'),
          life: 3000
        });
				this.$emit('role-assigned');
				this.visible = false;
			} catch (error) {
				//
			}
		},
		onHide() {
			this.user = undefined;
			this.userRoleForm = undefined;
		},
	},
}
</script>